export const LAST_VIEW_KEY = 'news_last_view_time'
